"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KeySystemOptionsGenerator = (function () {
    function KeySystemOptionsGenerator(drmType, keySystemName, licenseAcquisitionStrategy) {
        this.drmType = drmType;
        this.keySystemName = keySystemName;
        this.licenseAcquisitionStrategy = licenseAcquisitionStrategy;
    }
    KeySystemOptionsGenerator.prototype.getKeySystemOptions = function (drmConfiguration) {
        if (this.drmType === drmConfiguration.type) {
            return {
                type: this.keySystemName,
                getLicense: this.licenseAcquisitionStrategy.createGetLicense(drmConfiguration),
            };
        }
        return null;
    };
    return KeySystemOptionsGenerator;
}());
exports.default = KeySystemOptionsGenerator;
